import "./IconPerfIncome.scss";
import { ReactComponent as PerfIncomeIcon } from "./svg/icon_perfIncome.svg";

type Props = {
  active?: boolean;
};

export const IconPerfIncome = ({ active = false }: Props) => {
  return (
    <span className={`IconPerfIncome${active ? " IconPerfIncome--active" : ""}`}>
      <PerfIncomeIcon />
    </span>
  );
};
